export default "__VITE_ASSET__CsPPW8_b__"